import Header from "../components/desktop/Header";
import Sidebar from "../components/desktop/Sidebar";
import { Outlet } from "react-router-dom";

import "./DesktopLayout.css";

export default function DesktopLayout() {
  return (
    <div className="desktop-layout">
      <Header />

      <div className="desktop-body">
        <Sidebar />

        <main className="desktop-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}